import React from 'react';
import Editor, { loader } from '@monaco-editor/react';

loader.config({
  paths: {
    vs: '/monaco/vs'
  }
});

const getLanguage = (filePath) => {
  const safePath = String(filePath || '');
  const ext = safePath.includes('.') ? safePath.split('.').pop().toLowerCase() : '';

  const languageMap = {
    js: 'javascript',
    jsx: 'javascript',
    ts: 'typescript',
    tsx: 'typescript',
    json: 'json',
    html: 'html',
    css: 'css',
    py: 'python',
    md: 'markdown',
    yml: 'yaml',
    yaml: 'yaml',
    sh: 'shell',
    bash: 'shell',
    txt: 'plaintext'
  };

  return languageMap[ext] || 'plaintext';
};

export default function CodeEditor({ filePath, content, onChange }) {
  const safeContent = typeof content === 'string' ? content : String(content ?? '');

  const handleChange = (value) => {
    if (typeof onChange === 'function') {
      onChange(String(value ?? ''));
    }
  };

  return (
    <Editor
      height="100%"
      language={getLanguage(filePath)}
      value={safeContent}
      onChange={handleChange}
      theme="vs-dark"
      options={{
        fontSize: 14,
        minimap: { enabled: false },
        automaticLayout: true,
        scrollBeyondLastLine: false,
        wordWrap: 'on'
      }}
    />
  );
}
